import React from 'react';
import '../../../style/timeLineList.css';
import Button from "../../button";
import CenteredDots from "../centeredDots";
import FormResponseMessage from "../../formResponseMessage";

const TimeLineList = (props) => {
    return (
        <div className={'time-line-list'}>
            {props.listItems.map( (item, index) => (
                <div className={'row'} key={index}>
                    <div className={'col-sm-12'}>
                        <div className={'col-sm-3'}>
                            <span className={'time-line-list__header'}>{item.issuer}</span>
                        </div>
                        <div className={'col-sm-9'}>
                            <span className={'time-line-list__header'}>{item.label}</span>
                        </div>
                    </div>
                    <div className={'col-sm-12'}>
                        <div className={'col-sm-3'}>
                            <span >{item.date}</span>
                        </div>
                        <div className={'col-sm-9'}>
                            {item.body}
                        </div>
                    </div>
                    {props.shouldDisplayActions && (
                        <div className={'col-sm-12'}>
                            <div className={'col-sm-3 col-sm-offset-3'}>
                                <Button
                                    clickHandler={() => props.onAccept(item)}
                                    wrapper="btn-wrapper"
                                    btnType="button"
                                    btnStyle={'btn btn-primary btn-xs sharp yellow'}
                                    label="Accept"
                                />
                                <Button
                                    clickHandler={() => props.onReject(item)}
                                    wrapper="btn-wrapper"
                                    btnType="button"
                                    btnStyle={'btn btn-primary btn-xs sharp white'}
                                    label="Reject"
                                />
                            </div>
                            {(
                                props.patchingItemId
                                && props.patchingItemId.toString() === item.id.toString()
                            ) && (
                                <div className={'col-sm-1'}>
                                    <CenteredDots/>
                                </div>
                            )}
                        </div>
                    )}
                    {(
                        props.errorItemId
                        && props.errorItemId.toString() === item.id.toString()
                    ) && (
                        <div className={'col-sm-12'}>
                            <FormResponseMessage
                                Message={props.errorMessage}
                                CenterWrapper="col-sm-9 col-sm-offset-3 mt-15"
                                MessageStyle="formResponseMessage-reject"
                            />
                        </div>
                    )}
                    {(index + 1 < props.listItems.length) && (
                        <div className={'col-sm-12'}>
                            <div className={'col-sm-12'}>
                                <hr className="generalTab-hr"/>
                            </div>
                        </div>
                    )}
                </div>
            ))}
        </div>
    )
};

export default TimeLineList;